import ResetPasswordComponent from "../component/resetPassword/resetPassword";

function ResetPasswordPage() {
  return <ResetPasswordComponent />;
}
export default ResetPasswordPage;
